module.exports = __webpack_public_path__ + "static/media/thumbnailMisconceptions.0184ace7.jpg";